import { Icon24Check } from "immigram-ui-cmon/src/components/Icons";
import clsxm from "immigram-ui-cmon/src/lib/clsxm";
import { Fragment } from "react";

interface Step {
  title: string;
  slug: string;
  url?: string;
  disabled?: boolean;
  isSucceed?: boolean;
}

interface StepperProps {
  currentIndex: number;
  steps: Step[];
  className?: string;
  onClick?: (slug: string) => void;
}

const Stepper = (props: StepperProps) => {
  return (
    <div
      className={clsxm(
        "mb-8 flex items-center gap-x-4 text-base",
        props.className
      )}
    >
      {props.steps.map((x, index) => {
        const isCurrent = props.currentIndex === index;
        const isDisabled = x.disabled;
        const isHoverable = !isDisabled && !isCurrent;

        const InnerComponent = () => (
          <span className="group flex cursor-pointer items-center gap-x-2">
            <span
              className={clsxm(
                "flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gray-100 font-semibold text-black-900 transition",
                isDisabled && ["bg-gray-50", "text-black-300"],
                isHoverable ? "group-hover:text-black-600" : "cursor-default",
                isCurrent && [
                  "bg-black-900",
                  "text-white-900",
                  isHoverable && "group-hover:bg-black-600",
                ]
              )}
            >
              {x.isSucceed ? <Icon24Check /> : index + 1}
            </span>
            <span
              className={clsxm(
                "whitespace-nowrap font-semibold text-black-900 transition",
                isDisabled && "text-black-300",
                !isHoverable ? "cursor-default" : "group-hover:text-black-600"
              )}
            >
              {x.title}
            </span>
          </span>
        );

        return (
          <Fragment key={x.title}>
            {index !== 0 && (
              <div className="h-[1px] w-5 border-t border-t-black-100"></div>
            )}

            {isDisabled || isCurrent ? (
              <InnerComponent />
            ) : x.url ? (
              <a href={x.url}>
                <InnerComponent />
              </a>
            ) : (
              <a
                onClick={(event) => {
                  if (!props.onClick) {
                    return;
                  }

                  event.preventDefault();
                  props.onClick(x.slug);
                }}
              >
                <InnerComponent />
              </a>
            )}
          </Fragment>
        );
      })}
    </div>
  );
};

export default Stepper;
